export default {
  list: [
    {
      title: 'فعال',
      value: 'ACTIVE'
    },
    {
      title: 'غیرفعال',
      value: 'DISABLE'
    }
  ],
  values: {
    ACTIVE: 'ACTIVE',
    DISABLE: 'DISABLE'
  }
};